import { Center, Loader, Text } from "@mantine/core"
import { Accordion } from "@mantine/core";
import AccountCard, { Account } from "./AccountCard"
import { AddCalendarAccountWrapper } from "./AddCalendarAccount";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { useEffect, useState } from "react";

export const AccountTab = ({ accounts, updateAccounts }: { accounts: Account[], updateAccounts: () => void }) => {
    const { t } = useTranslation(['app']);
    const { user, isAuthenticated } = useAuth();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const [errorParam, _] = useState(queryParams.get('error'));

    useEffect(() => {
        if (isAuthenticated !== null) {
            setIsLoading(false);
        }
    }, [isAuthenticated]);

    return (
        <>
            {isLoading && <Center my='xl'><Loader /></Center>}
            {accounts && accounts.length > 0 ?
                <div className='display-5 my-4'>{t("dashboard.connect-account")}</div>
                :
                <div className='display-5 my-4'></div>
            }
            {accounts && accounts.length === 1 &&
                <div>
                    <div className="alert alert-success" role="alert">
                        <span className='fw-bold'> {t("dashboard.one-account")} ✅ </span><br />
                        {t("dashboard.second-account")}
                    </div>
                </div>
            }
            {errorParam === 'scope-error' &&
                <Center>
                    <Text c='red' mb='sm'>
                        {t('scope_error.short_description')}
                    </Text>
                </Center>
            }
            <AddCalendarAccountWrapper user={user} accounts={accounts} updateAccounts={updateAccounts} />
            {accounts && accounts.length > 0 &&
                <>
                    <div className='display-5 my-4'>{t("dashboard.connected-accounts")}</div>

                    <Accordion variant='contained'>
                        {accounts.map((account) => (
                            <AccountCard key={account.uuid} account={account} />
                        ))}
                    </Accordion>
                </>
            }
        </>
    )
}